var render = function render(_c,_vm){return _c('cta',{staticClass:"link--cta",attrs:{"tag":"recess-link","sanity-link":{ url: _vm.props.url, external: _vm.props.external },"fill":""}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }